import { render, staticRenderFns } from "./Estudiante.vue?vue&type=template&id=264d8807&scoped=true"
import script from "./Estudiante.vue?vue&type=script&lang=js"
export * from "./Estudiante.vue?vue&type=script&lang=js"
import style0 from "./Estudiante.vue?vue&type=style&index=0&id=264d8807&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264d8807",
  null
  
)

export default component.exports